export default __webpack_public_path__ + "static/media/image_9.8db527ad.jpg";